import { number, object, string } from 'yup';

export interface IRaffleForm {
  name: string;
  participantsMaxCount: number;
  rewardValue: string;
  rewardImageId: string;
}

export const initialValues: IRaffleForm = {
  name: '',
  participantsMaxCount: 0,
  rewardValue: '',
  rewardImageId: '',
};

export const validationSchema = object().shape({
  name: string().trim().required('Name is required'),
  participantsMaxCount: number().min(1, 'Must be at least 1').required('Max count is required'),
  rewardImageId: string().trim().required('Reward image is required'),
});
